import { jsx } from "react/jsx-runtime";
import { SvgIcon, useTheme } from "@mui/material";
function NoColorIcon() {
  const {
    vars: {
      palette: { error }
    }
  } = useTheme();
  return /* @__PURE__ */ jsx(SvgIcon, { viewBox: "0 0 22 22", children: /* @__PURE__ */ jsx("path", { d: "M1 1L21 21", stroke: error.main, strokeWidth: "2" }) });
}
export {
  NoColorIcon
};
//# sourceMappingURL=NoColorIcon.js.map
